/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type PowerConsumptionControllerV1GetPowerConsumptionReportStatusItem =
  (typeof PowerConsumptionControllerV1GetPowerConsumptionReportStatusItem)[keyof typeof PowerConsumptionControllerV1GetPowerConsumptionReportStatusItem];

export const PowerConsumptionControllerV1GetPowerConsumptionReportStatusItem = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
  UNPLUGGED: 'unplugged',
} as const;
